// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Pushpin(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Pushpin" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M7.05892 2H16.5671C16.5671 2.76919 15.6012 3.82266 14.8073 3.82266L15.4841 10.2496C16.7818 10.5185 17.7549 11.6359 17.7549 12.9734L13.0058 13V20.5L12 22L11.0041 20.5V13L6.25488 12.9734C6.25488 11.6359 7.22794 10.5185 8.52562 10.2496L9.20248 3.82266C8.40858 3.82266 7.05892 2.76919 7.05892 2Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Pushpin.js.map